import { debounce } from './utility.js';

jQuery( function( $ ) {
    const slider = $( '.carde-blocks' );
    if ( slider.length === 0 ) return;
    const mediaMatcher = window.matchMedia( '(min-width: 1024px)' );
    const owlOptions = {
        loop: false,
        rewind: true,
        responsiveClass: false,
        dots: false,
        nav: true,
        center: true,
        margin: 20,
        autoplay: false,
        items: 1,
        navContainerClass: 'owl-nav buttons',
        navElement: 'button',
        navText: [
            '<span class="sr-only">Previous Slide</span><svg height="10" width="6" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="M4.998 10.012a.997.997 0 0 1-.707-.293l-4-4a1.004 1.004 0 0 1 0-1.414l4-4a1 1 0 1 1 1.414 1.414L2.412 5.012l3.293 3.293c.187.188.293.442.293.707 0 .549-.452 1-1 1Z" fill="currentColor" /></svg>',
            '<span class="sr-only">Next Slide</span><svg height="10" width="6" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="M1.012 10.012c.265 0 .52-.105.707-.293l4-4a1.004 1.004 0 0 0 0-1.414l-4-4A1 1 0 1 0 .305 1.719l3.293 3.293L.305 8.305a1.002 1.002 0 0 0-.292.707c0 .549.451 1 .999 1Z" fill="currentColor" /></svg>'
        ],
        navClass: ['owl-prev button', 'owl-next button'],
    };

    if ( !mediaMatcher.matches ) slider.owlCarousel( owlOptions );

    window.addEventListener( 'resize', debounce( () => {
        slider.owlCarousel( mediaMatcher.matches ? 'destroy' : owlOptions );
    }, 300 ) );
} );